import React, {useEffect, useState} from 'react'
import {getFromLocalStorageWithDefault, saveToLocalStorage} from "../../../util/localStorageZugriff";
import VeranstalterLeagueOverview from "./VeranstalterLeagueOverview";
import VeranstalterTournamentOverview from "./VeranstalterTournamentOverview";

export default function VeranstalterDashboardEventsOverview({eventOperatorId, userId, counter}) {

    const [tabValue, setTabValue] = useState(getFromLocalStorageWithDefault("dh_eventoperator_dashboard_tab", "events"));

    useEffect(() => {
        saveToLocalStorage("dh_eventoperator_dashboard_tab", tabValue);
    },[tabValue]);

    const erzeugeTab = (value, key) => {
        return <div style={{
            color: "black", fontSize: 20, width: "50%",
            marginTop: 5,
            marginLeft: 5, cursor: "pointer",
            borderBottom: tabValue === key ? "2px solid red" : "none", textAlign: "center"
        }}
                    onClick={() => setTabValue(key)}>
            {value.toUpperCase()}
        </div>
    }

    const showLeagues = () => {
        return <VeranstalterLeagueOverview userId={userId} eventOperatorId={eventOperatorId} counter={counter}/>
    }

    const showEvents = () => {
        return <VeranstalterTournamentOverview userId={userId} eventOperatorId={eventOperatorId} counter={counter}/>
    }

    return <div className="col-12 md:col-12 lg:col-10" style={{padding: 10}}>
        <div className="ligashortoverview" style={{height: "100%", borderLeft: "10px solid #0497ae"}}>
            <div style={{marginTop: 10, marginBottom:10}}>
                <div style={{display: "flex", flexWrap: "nowrap"}}>
                    {erzeugeTab("Events", "events")}
                    {erzeugeTab("Ligen", "leagues")}
                </div>
            </div>
            {tabValue === "events" && showEvents()}
            {tabValue === "leagues" && showLeagues()}
        </div>
    </div>
}